import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';
import { NASIOL } from '../nasiolContent';

const TABS = [
  {
    id: 'ecommerce',
    label: 'E-commerce',
    hint: 'Catálogo $160',
  },
  {
    id: 'publicidad',
    label: 'Publicidad',
    hint: 'Redes mensuales',
  },
];

const ProposalTabs = ({ tab, onChange }) => (
  <Box
    component="nav"
    aria-label="Propuestas Nasiol Venezuela"
    position="sticky"
    top={0}
    zIndex={20}
    px={{ xs: 1.5, sm: 3 }}
    py={1.25}
    sx={{
      bgcolor: 'rgba(243,237,227,0.94)',
      backdropFilter: 'blur(12px)',
      borderBottom: `1px solid ${NASIOL.sandDeep}`,
      boxShadow: '0 8px 24px rgba(11,61,74,0.06)',
    }}
  >
    <Box
      maxWidth={560}
      mx="auto"
      display="grid"
      gridTemplateColumns="1fr 1fr"
      p={0.5}
      borderRadius={2}
      bgcolor={NASIOL.white}
      border={`1px solid ${NASIOL.sandDeep}`}
      sx={{ gap: 0.5 }}
    >
      {TABS.map((item) => {
        const active = tab === item.id;
        return (
          <ButtonBase
            key={item.id}
            onClick={() => onChange(item.id)}
            aria-pressed={active}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              px: { xs: 1.5, sm: 2 },
              py: { xs: 1.15, sm: 1.35 },
              borderRadius: 1.5,
              transition: 'background-color 0.2s ease, color 0.2s ease',
              bgcolor: active ? NASIOL.ocean : 'transparent',
              color: active ? NASIOL.white : NASIOL.inkMuted,
              '&:hover': {
                bgcolor: active ? NASIOL.oceanDeep : NASIOL.sand,
                color: active ? NASIOL.white : NASIOL.ink,
              },
            }}
          >
            <Typography
              sx={{
                fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                fontWeight: 800,
                fontSize: { xs: '0.95rem', sm: '1.05rem' },
                lineHeight: 1.2,
              }}
            >
              {item.label}
            </Typography>
            <Typography
              sx={{
                mt: 0.25,
                fontFamily: '"Source Sans 3", "Outfit", sans-serif',
                fontWeight: 600,
                fontSize: '0.72rem',
                opacity: active ? 0.85 : 0.75,
              }}
            >
              {item.hint}
            </Typography>
          </ButtonBase>
        );
      })}
    </Box>
  </Box>
);

ProposalTabs.propTypes = {
  tab: PropTypes.oneOf(['ecommerce', 'publicidad']).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ProposalTabs;
